<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="升级条件名称">
                  <el-input style="width: 186px;" v-model="queryForm.conditionName"></el-input>
              </el-form-item>
              <el-form-item label="升级条件类型">
                  <!-- <el-input  v-model="queryForm.conditionType"></el-input> -->
                  <el-select
                    size="small"
                    style="width: 186px"
                    v-model="queryForm.conditionType"
                  >
                    <el-option
                      v-for="item in auditStatus"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否激活">
                  <!-- <el-input  v-model="queryForm.isActive"></el-input> -->
                  <el-select
                      style="width: 186px;"
                      v-model="queryForm.isActive"
                      size="small"
                      placeholder="请选择"
                  >
                      <el-option
                          label="是"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="否"
                          :value="0"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="升级条件介绍">
                  <el-input style="width: 186px;" v-model="queryForm.conditionIntro"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelUpgradeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelUpgrade"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editModelUpgrade(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelUpgrade(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshModelUpgradeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelUpgradeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="conditionName"
        label="升级条件名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="conditionType"
        label="升级条件类型"
        min-width="180"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isActive"
        label="是否激活"
        min-width="180"
      >
        <template slot-scope="scop">
          {{ scop.row.isActive == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="conditionIntro"
        label="升级条件介绍"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <MgJzD :typeId="scop.row.dictType" style="margin-left: 3px;"></MgJzD>
            <div @click="checkModelUpgrade(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editModelUpgrade(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteModelUpgrade(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelUpgradeStates[modelUpgradeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelUpgrade"
          ref="modelUpgradeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <!-- <el-form-item
            label="升级条件名称"
            prop="conditionName"
          >
            <el-input
              size="small"
              style="width: 186px;"
              v-model="modelUpgrade.conditionName"
              :disabled="modelUpgradeState == 'check'"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="升级条件名称"
            prop="conditionType"
          >
            <!-- <el-input
              size="small"
              v-model="modelUpgrade.conditionType"
              :disabled="modelUpgradeState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="modelUpgrade.conditionType"
              :disabled="modelUpgradeState == 'check'"
            >
              <el-option
                v-for="item in auditStatus"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否激活"
            prop="isActive"
          >
            <!-- <el-input
              size="small"
              v-model="modelUpgrade.isActive"
              :disabled="modelUpgradeState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 186px;"
                v-model="modelUpgrade.isActive"
                size="small"
                placeholder="请选择"
                :disabled="modelUpgradeState == 'check'"
            >
                <el-option
                    label="是"
                    :value="1"
                ></el-option>
                <el-option
                    label="否"
                    :value="0"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="升级条件介绍"
            prop="conditionIntro"
          >
            <el-input
              size="small"
              style="width: 186px;"
              v-model="modelUpgrade.conditionIntro"
              :disabled="modelUpgradeState == 'check'"
            ></el-input>
          </el-form-item>
		  <el-form-item
		    label="字典类型"
		    prop="dictType"
		  >
		    <el-input
		      size="small"
		      style="width: 186px;"
		      v-model="modelUpgrade.dictType"
		      :disabled="modelUpgradeState == 'check'"
		    ></el-input>
		  </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelUpgradeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlace.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelUpgradeList();
                    this.getModelUpgradeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelUpgradeList();
                    this.getModelUpgradeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     conditionName: '', //升级条件名称
                     conditionType: '', //升级条件类型
                     isActive: '', //是否激活
                     conditionIntro: '', //升级条件介绍
					 dictType: '', //字典类型
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelUpgradeState: 'add',
                modelUpgradeStates: {
                    add: '新建升级',
                    check: '查看升级',
                    edit: '修改升级'
                },

                multipleSelection: [],
                modelUpgradeList: [],
                modelUpgrade: {
                    id: '', //ID
                    conditionName: '', //升级条件名称
                    conditionType: '', //升级条件类型
                    isActive: '', //是否激活
                    conditionIntro: '', //升级条件介绍
					dictType: '', //字典类型
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    conditionName: [{ required: true, message: '升级条件名称不能为空', trigger: 'blur' }],
                    conditionType: [{ required: true, message: '升级条件类型不能为空', trigger: 'blur' }],
                    isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                    conditionIntro: [{ required: true, message: '升级条件介绍不能为空', trigger: 'blur' }],
					// dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                auditStatus:[],
            };
        },
        created() {
            this.getModelUpgradeList();
            this.getAuditStatus();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getcttpe(key){
              for(let i = 0; i < this.auditStatus.length; i++){
                  if(this.auditStatus[i].key == key){
                    return this.auditStatus[i].value;
                  }
                }
            },
            getAuditStatus() {
                get('/mpp/utils/getEnum', { enumType: 'model_upgrade_condition' }).then((res) => {
                    this.auditStatus = res.enumList;
                });
            },
            resetModelUpgradeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelUpgradeList = [];
            },
            resetDialog() {
                this.modelUpgradeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      conditionName: '', //升级条件名称
                      conditionType: '', //升级条件类型
                      isActive: '', //是否激活
                      conditionIntro: '', //升级条件介绍
                };
                this.getModelUpgradeList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelUpgrade = {
                      id: '', //ID
                      conditionName: '', //升级条件名称
                      conditionType: '', //升级条件类型
                      isActive: '', //是否激活
                      conditionIntro: '', //升级条件介绍
                };
            },
            submitForm() {
                if (this.modelUpgradeState == 'add') {
                    this.$refs.modelUpgradeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/upgrade/add`,{ ...this.modelUpgrade }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelUpgradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelUpgradeState == 'edit') {
                    this.$refs.modelUpgradeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/upgrade/edit`,{ ...this.modelUpgrade }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelUpgradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelUpgrade() {
                this.showDialog = true;
                this.modelUpgradeState = 'add';
            },
            checkModelUpgrade(modelUpgradeId) {
                console.log(modelUpgradeId);
                this.currentModelUpgradeId = modelUpgradeId;

                this.getModelUpgradeById();
                this.showDialog = true;
                this.modelUpgradeState = 'check';
            },
            editModelUpgrade(modelUpgradeId) {
                console.log('modelUpgrade', modelUpgradeId);
                if (modelUpgradeId) {
                    this.currentModelUpgradeId = modelUpgradeId;
                    this.getModelUpgradeById();
                } else {
                    this.modelUpgrade = { ...this.modelUpgrade, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelUpgradeState = 'edit';
            },
            deleteModelUpgrade(modelUpgradeId) {
                let ids = '';
                if (modelUpgradeId) {
                    ids = modelUpgradeId;
                } else {
                    ids = this.multipleSelection.map((modelUpgrade) => modelUpgrade.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/upgrade/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelUpgradeList();
                                this.getModelUpgradeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelUpgradeList() {
                this.resetModelUpgradeList();
                this.getModelUpgradeList();
            },
            getModelUpgradeList(query = {}) {
                this.loading = true;
                get(`/model/upgrade/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelUpgradeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelUpgradeById() {
                get(`/model/upgrade/get`,{ id: this.currentModelUpgradeId }).then((res) =>{
                    if(res.success){
                      this.modelUpgrade = { ...this.modelUpgrade, ...res.modelUpgrade };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelUpgradeList() {
                //this.btnLoading = true;
                exprotExcel(`/model/upgrade/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/upgrade/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/upgrade/importData`,formData);
              this.refreshModelUpgradeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelUpgradeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelUpgradeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>